import React from 'react';
import '../styles/sections/textWithImage.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import Slideshow from '../components/type1-slider';

function TextWithImage(props) {  
  const data = props.data;
  const portfolios = data.portfolio;
  function leadingZero(i){
    var j = i+1;
        j = "0"+j;
    return j.slice(-2);
  }

  return (
    <div className="textWithImage">
      <div className="innerBox">         
        <div className="contentSection" >
          <div dangerouslySetInnerHTML={{ __html: data.content }} />
          {data.list && 
            <div className="listing">
              <h3 className="sectionHeading">We can help you with</h3>
              <ul>
                {data.list.map((d,i) =>
                  <li key={i}><strong>{leadingZero(i)}</strong><span>/</span>{d}</li>
                )}
              </ul>
            </div>
          }
          { portfolios &&
            <div className="portfolioLinks">
              {portfolios.icons && 
                <div className={`logos col-${portfolios.icons.length}`}>
                {portfolios.icons.map((d, i) =>                  
                    <Link key={i} to={d.url === "" ? "/portfolio" : d.url}><img key={i} src={d.image} alt={d.alt} /></Link>                                                        
                )}
                </div>
              }
              <Link to="/portfolio" className={`portfolioLink btn pill quote ${portfolios.class}`}>Checkout Our Portfolio</Link>
            </div>
          }  
          {data.button &&
            <div className="button">
              <br/><br/>
                <Link
                  to={data.button.url}
                  className={`btn pill ${data.button.class}`}>
                  { data.button.text }
                </Link>
            </div>              
          }                  
        </div>
        <div className={`imageContainer ${data.position}`}>
          <div className={data.class}>
            {data.slider &&
              <Slideshow data={data.slider} />
            }
            <LazyLoadImage
              alt={data.content}              
              effect="blur"
              src={data.image} // use normal <img> attributes as props
            />
            </div>
        </div>
      </div>      
    </div>
  )
};

export default TextWithImage; 